import client from '@/api/client';
import { gql } from '@apollo/client';

const getClassExercises = (
  params: {
    lessonId: number;
    sessionId: string;
  },
) => client.query({
  query: gql`
    query($lessonId: Int, $sessionId: String) {
      getExercises(lessonId: $lessonId, sessionId: $sessionId) {
        id,
        activity,
        alias,
        exerciseProgress {
          id,
          testInfo {
            right,
            wrong,
            total,
          }
        },
        priority,
        required,
        title,
      }
    }
  `,
  variables: {
    ...params,
  },
});

const getDontKnow = (state: string) => client
  .query({
    query: gql`
    query($state: String) {
      getClientState(
        state: $state
      ) {
        id
        state
        value
      }
    }
  `,
    variables: {
      state,
    },
  });

const setDontKnow = (
  state: string,
  value: string,
) => client
  .mutate({
    mutation: gql`
      mutation(
        $state: String,
        $value: String
      ) {
        setClientState(
          state: $state,
          value: $value
        ) {
          status
        }
      }
    `,
    variables: {
      state,
      value,
    },
  });

const updateDontKnow = (
  id: number,
  state: string,
  value: string,
) => client
  .mutate({
    mutation: gql`
    mutation(
      $id: Int,
      $state: String,
      $value: String
    ) {
      updateClientState(
        id: $id,
        state: $state,
        value: $value
      ) {
        status
      }
    }
  `,
    variables: {
      id,
      state,
      value,
    },
  });

const setTestResult = (result: string) => client
  .mutate({
    mutation: gql`
      mutation($result: TestResultInput) {
        setTestResult(result: $result) {
          status
        }
      }
    `,
    variables: {
      result,
    },
  });

const setExerciseResult = (result: string) => client
  .mutate({
    mutation: gql`
      mutation($result: TestResultInput) {
        setExerciseResult(result: $result) {
          status
        }
      }
    `,
    variables: {
      result,
    },
  });

const updateTestResult = (id: number, result: string) => client
  .mutate({
    mutation: gql`
      mutation($id: Int, $result: TestResultInput) {
        updateTestResult(id: $id, result: $result) {
          status
        }
      }
    `,
    variables: {
      id,
      result,
    },
  });

const patchUserAnswer = (id: number, result: string) => client
  .mutate({
    mutation: gql`
      mutation($id: Int, $result: HWResultInput) {
        patchUserAnswer(id: $id, result: $result) {
          status
        }
      }
    `,
    variables: {
      id,
      result,
    },
  });

const getExercises = (lessonId: number) => client.query({
  query: gql`
    query($lessonId: Int) {
      getExercises(lessonId: $lessonId) {
        activity,
        id,
      }
    }
  `,
  variables: {
    lessonId,
  },
});

export default {
  getClassExercises,
  getDontKnow,
  setDontKnow,
  updateDontKnow,
  setTestResult,
  setExerciseResult,
  patchUserAnswer,
  updateTestResult,
  getExercises,
};
